import SimpleStore from '../../utilities/SimpleStore'

const getLocaleFromLocalStorage = (): string =>
  SimpleStore.get('i18nextLng') || ''

export default getLocaleFromLocalStorage
